var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group-item',{attrs:{"name":"Transition"}},[_c('pp-select',{attrs:{"data-container":"transition-properties","items":_vm.transitions,"selected-val":_vm.transition},on:{"change":_vm.onTransitionChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }